import { getAuthenticationClient } from '@/authentication/getAuthenticationClient';
import { getApiHost,getLegaApiHost } from '@/conf';

import {
    ProjectionsClient,
    StatusClient,
    TraineesClient,
    WorksheetsClient,
    TraineeStatisticsClient,
}
    from '@/api/api.clients';

import {  TrainingClient}
    from '@/api/lega.clients';

const apiHost = getApiHost();
const legaApiHost = getLegaApiHost();
const fetchWrapper: { fetch: typeof window.fetch } = {
    async fetch(request, init?): Promise<Response> {
        const client =await  getAuthenticationClient();
        const token = await client.getTokenSilently() as string;

        return window.fetch(request, {
            ...init,
            headers: {
                ...init?.headers,
                Authorization: `Bearer ${token}`
            }
        });
    }
};

export const wordTrainingClient = new TrainingClient(legaApiHost, fetchWrapper);
export const statusClient = new StatusClient(apiHost, fetchWrapper);
export const projectionsClient = new ProjectionsClient(apiHost, fetchWrapper);
export const traineesClient = new TraineesClient(apiHost, fetchWrapper);
export const worksheetsClient = new WorksheetsClient(apiHost, fetchWrapper);
export const traineeStatisticsClient = new TraineeStatisticsClient(apiHost,fetchWrapper);



